import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HomePageSectionService extends HttpService<any, any> {
    constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
        super(httpClient, apiUrl, apiVersion, 'sections'); 
      }
getLayoutByViewType(view_type: string): Observable<any> {
    return this.getBy(`/admin?view_type=${view_type}`);
}
deleteSection(id: number | string): Observable<any> {
    return this.delete(id);
}

updateSectionStatus(id: number | string,payload: {is_active: boolean}): Observable<any> {
    return this.patch('', payload, `${id}/is-active`);
}

saveSectionLayout(payload:{ids: number[]}, view_type: string): Observable<any> {
    return this.update(payload, '', `reorder?view_type=${view_type}`);
}

saveNewSection(payload: any): Observable<any> {
    return this.create(payload, );
}

updateSection(payload: any, id: number): Observable<any> {
    return this.update(payload, '', id);
}

getSectionByID(id: number): Observable<any> {
    return this.getById(id);
}

getAllSections(view_type: string, page = 1, limit = 10): Observable<any> {
    return this.getAll(`?view_type=${view_type}&page=${page}&limit=${limit}`);
}

}